import api from "actions/api.js"

export function get(table) {
    return api(`${table}`)
}


/** WEBPACK FOOTER **
 ** ./src/actions/ref/api.js
 **/